import classnames from 'classnames';

import { PopupBuilderCustomContentSection } from '../contentTypes';
import { Div } from '../HTMLElement';
import { buildSpacingClassNamesFromContent, buildVisibilityClassNamesFromContent } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderCustomComponentProps extends PopupBuilderCustomContentSection {}

const PopupBuilderCustomComponent = ({ options }: PopupBuilderCustomComponentProps) => {
  const margin = options?.margin && buildSpacingClassNamesFromContent('m', options.margin);
  const visibility = options?.visibility;
  const visibilityClassNames = visibility && buildVisibilityClassNamesFromContent(visibility);

  return (
    <Div
      className={classnames('popup-builder-custom-component', options?.classes)}
      uiClassName={{ bs5: classnames(margin, visibilityClassNames) }}
    >
      Custom component
    </Div>
  );
};

export type PopupBuilderCustomComponentVariants = '';

const PopupBuilderCustomComponentController = (props: PropsWithCustomComponent<PopupBuilderCustomComponentProps>) => (
  <VariantsController<PopupBuilderCustomComponentProps, PopupBuilderCustomComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderCustomComponent,
      name: 'PopupBuilderCustomComponent',
    }}
  />
);
export { PopupBuilderCustomComponentController as PopupBuilderCustomComponent };
